import React, { useEffect, useState } from 'react'
import {
  CHECK_DEFAULT_VALUES,
  DROPDOWN_DEFAULT_VALUES_MAX,
  DROPDOWN_DEFAULT_VALUES_MIN,
  SCHEDULE_VALUES,
} from '@modules/admin/groups/components/specialitiesScheduleModal/constants'
import {
  correctSchedules,
  createChecks,
  createDropdowns,
  createTable,
  isEmpty,
} from '@modules/admin/groups/components/specialitiesScheduleModal/actions'
import SimpleModal from '@modules/admin/common/modal/simpleModal'
import { CheckBoxItem, CheckSide, HourSide, Title, Toolbar, Top, WrapSchedule } from '@modules/admin/groups/styled'
import Button from '@modules/admin/common/button'
import { WarningModal } from '@modules/admin/groups/template'

export const ScheduleModal = ({ hide, loading, onChange, selectedSpeciality }) => {
  const [splitted, setSplitted] = useState(false)
  const dropValues = splitted ? DROPDOWN_DEFAULT_VALUES_MAX : DROPDOWN_DEFAULT_VALUES_MIN
  const [reset, setReset] = useState(false)
  const [checkList, setCheckList] = useState(CHECK_DEFAULT_VALUES)
  const [dropList, setDropList] = useState(dropValues)
  const [data, setData] = useState(selectedSpeciality.schedules || SCHEDULE_VALUES)
  const [showNoDataModal, setShowNoDataModal] = useState(false)
  const [showWrongHoursModal, setShowWrongHoursModal] = useState(false)

  const addCheck = (item) => {
    let newList = { ...checkList }
    newList[item.key] = item.value
    setCheckList(newList)
  }

  const addDrop = ({ item, name }) => {
    let newList = { ...dropList }
    newList[name] = item.value
    setDropList(newList)
  }

  const removeDay = (day) => {
    let newList = data.map((el) => (el.day === day ? { ...el, ...DROPDOWN_DEFAULT_VALUES_MAX } : el))
    setData(newList)
  }

  const saveSchedule = () => {
    if (!correctSchedules(dropList)) {
      setShowWrongHoursModal(true)
      return
    }
    // when no dropDowns and checks are selected
    if (isEmpty(dropList) || isEmpty(checkList)) {
      setShowNoDataModal(true)
      return
    }

    let newList = [...data]
    for (const elem in checkList) {
      if (checkList[elem]) {
        let index = newList.findIndex((item) => {
          return item.day === elem
        })
        if (index > -1) {
          newList[index] = { ...newList[index], ...dropList }
        }
      }
    }
    setData(newList)
    setSplitted(false)
    setReset(true)
    setCheckList(CHECK_DEFAULT_VALUES)
  }

  useEffect(() => {
    if (reset) setReset(false)
  }, [reset])

  const validation = () => {
    save()
  }
  const save = () => {
    onChange(data)
  }
  console.log(data)
  const tableParams = { data, removeDay }
  return (
    <SimpleModal
      className="schedule-modal"
      title={'Dermatología'}
      hideModal={hide}
      loading={false}
      template={
        <WrapSchedule>
          <Top>
            <CheckSide>
              <Title>{'Dias activos'}</Title>
              {!reset && createChecks(addCheck)}
            </CheckSide>
            <HourSide>
              <Title>{'Horario'}</Title>
              {!reset && createDropdowns({ splitted, addDrop })}
              <CheckBoxItem>
                <input type="checkbox" checked={splitted} onClick={() => setSplitted(!splitted)} />
                {'Horario Partido'}
              </CheckBoxItem>
            </HourSide>
          </Top>
          <Button type="button" onClick={() => saveSchedule()}>
            {'Añadir otra franja horaria'}
          </Button>
          {createTable(tableParams)}
          <Toolbar>
            <Button type="button" cancel onClick={hide}>
              {'Cancelar'}
            </Button>
            <Button type="button" onClick={() => validation()}>
              {'Guardar y finalizar'}
            </Button>
          </Toolbar>
          {showNoDataModal && (
            <WarningModal text={'There is no data chosen!'} closeFn={() => setShowNoDataModal(false)} />
          )}
          {showWrongHoursModal && (
            <WarningModal text={'Horas incorrectas'} closeFn={() => setShowWrongHoursModal(false)} />
          )}
        </WrapSchedule>
      }
    />
  )
}
